export const VIEWS = {
    CONFIRMATION: 'CONFIRMATION',
    REASON: 'REASON',
}
